export default class ContactSearchResult {
  firstName: string;
  lastName: string;
  contactType: string;
  id: number;

  get fullName(): string {
    if (!this.id) return "";
    return `${this.firstName} ${this.lastName} - ${this.id}`;
  }
}



// WEBPACK FOOTER //
// ./src/models/resource-management/contact-search.ts